import React from 'react';
import * as S from './styles'
import {Container, Text1, Title1} from "../../../styles/components";
import {Button} from "../../Button";

import {ReactComponent as Cup} from './cup.svg';
import {FormattedMessage} from "react-intl";

export const Content6 = () => {
    return (
        <Container id={"donate"}>
            <S.Content>
                <S.Body>
                    <div><Cup/></div>
                    <S.Block>
                        <Title1><FormattedMessage id="thanksTitle"/></Title1>
                        <Text1><FormattedMessage id="thanksText1"/></Text1>
                        <S.SupportText><FormattedMessage id="thanksText2"/></S.SupportText>
                        <S.ButtonGroup>
                            <Button>EURO</Button>
                            <Button>CHF</Button>
                            <Button>PAYPAL</Button>
                        </S.ButtonGroup>
                    </S.Block>
                </S.Body>
            </S.Content>
            <S.MobileContent>
                <Title1><FormattedMessage id="thanksTitle"/></Title1>
                <Cup/>
                <S.Block>
                    <Text1><FormattedMessage id="thanksText1"/></Text1>
                    <S.SupportText><FormattedMessage id="thanksText2"/></S.SupportText>
                    <S.ButtonGroup>
                        <Button>EURO</Button>
                        <Button>CHF</Button>
                        <Button>PAYPAL</Button>
                    </S.ButtonGroup>
                </S.Block>
            </S.MobileContent>
        </Container>
    );
}